/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-11 11:11:10
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-02 11:42:07
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorHomepage/TopConfigs/HomePageSEOSetting/index.tsx
 */
import React from 'react';
import { InfoCircleFilled } from '@ant-design/icons';
import css from './css.less';

import { useSelector, useDispatch } from 'react-redux';

import _HomepageSEOSetting from 'src/pages/SalesChannelContentEditor/Components/HomepageSEOSetting';
import { Collapse } from '@/src/components/Antd';
import { ErrorDisplay } from 'src/constrains/SalesChannelPreviewPageComponents/CollapseErrors';

import { EnumCollapseId } from '../../common';

import {
  getCollapseStatus,
  onSeoSettingChange,
  onCollapseOpen,
  getCollapseValidationMsgDisplay,
  onErrorChange,
} from '../../slice';
import { validateSeoSetting } from '../../tools';

import styles from './css.less';

const HomePageSEOSetting = (props) => {
  const { isPrimary } = props;
  const _d = useDispatch();
  const _open = useSelector(getCollapseStatus(EnumCollapseId.seoSetting));
  const {
    title,
    description,
    favicon = {},
  } = useSelector(
    (state: any) => state.salesChannelContent.homepage.seoSetting,
  );

  const { display: _display, hasError } = useSelector(
    getCollapseValidationMsgDisplay(EnumCollapseId.seoSetting),
  );

  const handleOnSeoSettingTitleChange = (title) => {
    _d(onSeoSettingChange({ title: title }));
  };

  const handleOnSeoSettingDescriptionChange = (des) => {
    _d(onSeoSettingChange({ description: des }));
  };

  const handleOnSeoSettingFaviconChange = (img) => {
    _d(onSeoSettingChange({ favicon: img }));
  };

  const handleOnCollapseOpen = (open) => {
    if (open) {
      _d(onCollapseOpen({ idArr: [EnumCollapseId.seoSetting] }));
    } else {
      _d(onCollapseOpen({ idArr: [] }));
    }
  };

  const _err = validateSeoSetting({ title, description, favicon });

  React.useEffect(() => {
    if (!hasError && _err.length > 0) {
      _d(onErrorChange({ id: EnumCollapseId.seoSetting, status: true }));
    }
    if (hasError && _err.length === 0) {
      _d(onErrorChange({ id: EnumCollapseId.seoSetting, status: false }));
    }
  }, [_err]);

  const renderTitle = () => (
    <div className={styles.title}>
      <span>{'Home Page SEO Setting'}</span>
      {_display && hasError && <InfoCircleFilled className={styles.iconWarn} />}
    </div>
  );

  const handleErr = React.useMemo(() => {
    if (_display) {
      return <ErrorDisplay open={_open} err={_err} />;
    } else {
      return null;
    }
  }, [_err, _display, _open]);

  return (
    <div className={css.container}>
      <Collapse
        err={handleErr}
        id={EnumCollapseId.seoSetting}
        open={_open}
        title={renderTitle()}
        content={
          <_HomepageSEOSetting
            onTitleChange={handleOnSeoSettingTitleChange}
            onDescriptionChange={handleOnSeoSettingDescriptionChange}
            onFavChange={handleOnSeoSettingFaviconChange}
            title={title}
            description={description}
            favicon={favicon}
            isPrimary={isPrimary}
          />
        }
        clickToExpand
        expandOffset={12}
        onClickTrigger={handleOnCollapseOpen}
      />
    </div>
  );
};
export default HomePageSEOSetting;
